import {Component, OnInit, AfterViewInit, ViewChild} from '@angular/core';
import {NgxSpinnerService} from "ngx-spinner";
import {MessageService} from "../../core/services/message.service";
import {PlanoService} from "../../services/plano.service";
import {Plano} from "../../models/plano";
import {SituacaoPlano} from "../../models/situacao-plano";
import {Router} from "@angular/router";
import {Login} from "../../models/login";
import {Perfil} from "../../models/perfil";
import {LoginService} from "../../services/login.service";
import {startWith, tap} from "rxjs/operators";
import {MatPaginator} from "@angular/material";
import {Document, Packer, Paragraph, TextRun, Header} from "docx";
import {saveAs} from "file-saver";
import {ConfiguracaoPlano} from "../../models/configuracao-plano";
import {FormControl, FormGroup} from "@angular/forms";
import {SituacaoPlanoService} from "../../services/situacao-plano.service";

@Component({
    selector: 'app-planos',
    templateUrl: './planos.component.html',
    styleUrls: ['./planos.component.scss']
})
export class PlanosComponent implements OnInit {

    public planos: Array<Plano> = [];
    public carregando: boolean = false;
    public form: FormGroup;
    public situacoes: Array<SituacaoPlano>;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    resultsLength = 0;

    constructor(private situacaoPlanoService: SituacaoPlanoService, private loadingService: NgxSpinnerService, private messageService: MessageService, private planoService: PlanoService, private router: Router, private loginService: LoginService) {

    }


    ngOnInit() {
        let login: Login = this.loginService.getAuth();
        let url: string;
        if (login) {
            if (login.perfil != Perfil.GESTOR) {
                url = "/gerencial";
                this.router.navigateByUrl(url);
            }
        } else {
            url = "/login";
            this.router.navigateByUrl(url);
        }
        this.form = new FormGroup({
            cod_situacao: new FormControl(null)
        });

        //this.carregarSituacoes();
        this.carregarPlanos();
    }

    carregarSituacoes(): void {
        this.loadingService.show();
        this.situacoes = [];
        this.situacaoPlanoService.listAll().subscribe((situacoes: Array<SituacaoPlano>) => {
            this.situacoes = situacoes;
            this.loadingService.hide();
        }, () => {
            this.loadingService.hide();
        });
    }


    carregarPlanos(situacao: string = null): void {
        this.planos = [];
        this.loadingService.show();
        this.carregando = true;
        this.planoService.listAll(null, null, null, situacao, true).subscribe((planos: Array<Plano>) => {
            if (planos.length > 0) {
                planos.forEach((plano: Plano) => {
                    plano.pode_preencher = true;
                    if (plano.situacao_plano && plano.situacao_plano.sgl_situacao_plano == SituacaoPlano.FINALIZADO) {
                        plano.pode_preencher = false;
                    }
                    this.planos.push(plano);
                });
            }
            this.loadingService.hide();
            this.carregando = false;
        }, () => {
            this.loadingService.hide();
            this.carregando = false;
        });
    }

    alterarSituacaoPreenchimento(cod_plano: number): void {
        this.loadingService.show();
        this.carregando = true;
        let sgl_situacao_plano: string = SituacaoPlano.EM_PREENCHIMENTO;
        this.planoService.updateSituacao(cod_plano, sgl_situacao_plano).subscribe(() => {
            this.loadingService.hide();
            this.carregando = false;
            this.messageService.showSuccess("Status do plano salvo com sucesso");
            this.carregarPlanos();
        }, (error: any) => {
            this.loadingService.hide();
            this.carregando = false;
            this.messageService.showResponseError(error);
        });
    }

    exportarPdf(plano: number): void {
        this.planoService.exportPdf(plano);
    }

    exportarWord(plano: number): void {
        this.planoService.exportWord(plano);
    }

}
